import React from 'react';
import TurnoForm from '../components/TurnoForm';

const CrearTurnoTransportista = () => {
  return <TurnoForm modo="admin" soloUnProveedor={true} volverA="/admin-turnos" />;
};

export default CrearTurnoTransportista;
